/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Facebook_CoverInputs */

const cs_template_aspect_facebook_cover = /** @type {(inputs: Template_Aspect_Facebook_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook cover`)
};

const en_template_aspect_facebook_cover = /** @type {(inputs: Template_Aspect_Facebook_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook cover`)
};

/**
* | output |
* | --- |
* | "Facebook cover" |
*
* @param {Template_Aspect_Facebook_CoverInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_facebook_cover = /** @type {((inputs?: Template_Aspect_Facebook_CoverInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Facebook_CoverInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_facebook_cover(inputs)
	return cs_template_aspect_facebook_cover(inputs)
});